import React, { useContext, useEffect, useState } from "react";
import api from "../../../utils/axios";
import {
  Box,
  Button,
  Heading,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Select,
  Spinner,
  Table,
  Thead,
  Tbody,
  Tooltip,
  Tr,
  Th,
  Td,
  TableContainer,
  useDisclosure,
  Checkbox,
  Flex
} from "@chakra-ui/react";
import { UserContext } from "../../../context/UserContext";
import AdminUserFilter from "../../../components/AdminUserFilter";
import AdminUserTableFooter from "../../../components/AdminUserTableFooter";
import { hasPermission, renderArrow } from "../../../utils/helpers";
import { prettyPrintLastName } from "../../../utils/PrettyPrints";
import { ConfigContext } from "../../../context/ConfigContext";
// import AdminAssignGroups from "../../admin/assign-users/AdminAssignGroups";

function AdminManageRegistrationStatus() {
  const { user, language } = useContext(UserContext);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [updateScope, setUpdateScope] = useState("individual");

  const [filteredUsers, setFilteredUsers] = useState(null);
  const [pageLoading, setPageLoading] = useState(true);

  const [pageNumber, setPageNumber] = useState(1);
  const [pageTotal, setPageTotal] = useState(1);
  const [pageSize, setPageSize] = useState(50);
  const [pageNumberChange, setPageNumberChange] = useState(false);

  const [sortBy, setSortBy] = useState("");
  const [sortOrder, setSortOrder] = useState("");

  const [updateUser, setUpdateUser] = useState(null);
  const [updatedRegistrationStatus, setUpdatedRegistrationStatus] =
    useState(null);
  const [oldRegistrationStatus, setOldRegistrationStatus] = useState(null);
  const config = useContext(ConfigContext);
  // const [groups, setGroups] = useState([]);
  const [capacityCheck, setCapacityCheck] = useState(true);

  let classroomFull = false;
  let classroomFullFamily = false;
  let statusFromPAToAccepted = false;
  let groups = [];
  let groupCapacities = {};


  useEffect(() => {
    api.get("/api/users/process-expired-registration-tokens");
  }, []);

  function fetchGroupData() {
    api.get("/api/groups").then((res) => {
      // console.log("fetchGroupData", res.data);
      // setGroups(res.data);
      groups = res.data;
    });
  }

  useEffect(() => {
    fetchGroupData();
  }, [groups]);

  function prettyPrintUser(user) {
    if (!user) {
      return "";
    }

    let name = `${user.firstName} ${user.lastName}`;
    if (user.chineseName) {
      name += ` (${user.chineseName})`;
    }
    if (updateScope === "family") {
      name = `Family ${user.familyId}`;
    }

    const clearFieldMessage =
      updatedRegistrationStatus === "Not Attending"
        ? " This will remove group and dorm assignments for this user."
        : "";

    const emailMessage =
      updatedRegistrationStatus === "Waiting List" ||
        updatedRegistrationStatus === "Pending Acceptance" ||
        updatedRegistrationStatus === "Accepted"
        ? " Do you want to send an email notifying the user?"
        : " This will not send an email to the user.";

    return `Registration status for ${name} will be changed from "${updateUser?.registrationStatus}" to "${updatedRegistrationStatus}".${clearFieldMessage}${emailMessage}`;
  }

  function prettyPrintChurch(u) {
    if (!u.church) {
      return u.churchOther ? "Other" : "";
    }

    if (!u.church.tier || u.church.tier <= 0) {
      return u.church.name;
    }

    return u.church.name + "*".repeat(u.church.tier);
  }

  function isGroupMaxCapacityReached(g) {
    console.log("isGroupMaxCapacityReached");
    console.log("g:", g);
    if (!groupCapacities) { groupCapacities[g.name] = {} };
    console.log("groupCapacities:", groupCapacities);
    if (!groupCapacities.hasOwnProperty(g.name)) { groupCapacities[g.name] = { curr_cap: g.curr_occupancy }; };
    // if (!groupCapacities[g.name].hasOwnProperty("curr_cap")) { groupCapacities[g.name] = {curr_cap : 0}; };

    groupCapacities[g.name] = { curr_cap: groupCapacities[g.name].curr_cap + 1, max_cap: g.max_occupancy };
    console.log("groupCapacities:", groupCapacities);
    return groupCapacities[g.name].curr_cap > groupCapacities[g.name].max_cap ? true : false;
  }

  function getGroupByAgeGrade(updUser) {
    console.log("getGroupByAgeGrade");
    // 1. By age first
    classroomFull = false;
    let ugroup = [];
    switch (parseInt(updUser.age)) {
      case 0:
      case 1:
      case 2:
        ugroup = groups.filter((g) => g.name === "BT01");
        if (ugroup[0].curr_occupancy >= ugroup[0].max_occupancy)
          classroomFull = true;
        break;
      case 3:
      case 4:
        ugroup = groups.filter((g) => g.name !== "PK01");
        if (ugroup[0].curr_occupancy >= ugroup[0].max_occupancy)
          classroomFull = true;
        break;
      case 5:
      case 6:
        ugroup = groups.filter((g) => g.name !== "GK-1");
        if (ugroup[0].curr_occupancy >= ugroup[0].max_occupancy)
          classroomFull = true;
        break;
      case 7:
      case 8:
        ugroup = groups.filter((g) => g.name !== "G2-3");
        if (ugroup[0].curr_occupancy >= ugroup[0].max_occupancy)
          classroomFull = true;
        break;
      case 9:
      case 10:
      case 11:
      case 12:
        ugroup = groups.filter((g) => g.name !== "G4-5");
        if (ugroup[0].curr_occupancy >= ugroup[0].max_occupancy)
          classroomFull = true;
        break;
      default:
        console.log("default");
    };
    console.log("updUser.age, ugroup", updUser.age, ugroup)
    // 2. Adjusting by user's grade
    switch (updUser.grade) {
      case "0-2 Years Old":
        ugroup = groups.filter((g) => g.name === "BT01");
        if (ugroup[0].curr_occupancy >= ugroup[0].max_occupancy)
          classroomFull = true;
        break;
      case "3-4 Years Old":
        ugroup = groups.filter((g) => g.name === "PK01");
        if (ugroup[0].curr_occupancy >= ugroup[0].max_occupancy)
          classroomFull = true;
        break;
      case "5 Years Old":
      case "Kindergarten":
      case "Grade 1":
        ugroup = groups.filter((g) => g.name === "GK-1");
        if (ugroup[0].curr_occupancy >= ugroup[0].max_occupancy)
          classroomFull = true;
        break;
      case "Grade 2":
      case "Grade 3":
        ugroup = groups.filter((g) => g.name === "G2-3");
        if (ugroup[0].curr_occupancy >= ugroup[0].max_occupancy)
          classroomFull = true;
        break;
      case "Grade 4":
      case "Grade 5":
        ugroup = groups.filter((g) => g.name === "G4-5");
        if (ugroup[0].curr_occupancy >= ugroup[0].max_occupancy)
          classroomFull = true;
        break;
      case "Grade 6":
      case "Grade 7":
      case "Grade 8":
        ugroup = groups.filter((g) => g.name === "E01");
        if (ugroup[0].curr_occupancy >= ugroup[0].max_occupancy)
          classroomFull = true;
        break;
      case "Grade 9":
      case "Grade 10":
        ugroup = groups.filter((g) => g.name === "E02");
        if (ugroup[0].curr_occupancy >= ugroup[0].max_occupancy)
          classroomFull = true;
        break;
      case "Grade 11":
      case "Grade 12":
        ugroup = groups.filter((g) => g.name === "E04");
        if (ugroup[0].curr_occupancy >= ugroup[0].max_occupancy)
          classroomFull = true;
        break;
      case "College":
        if (updUser.preferredLanguage === "English") {
          ugroup = groups.filter((g) => g.name === "E05");
          if (ugroup[0].curr_occupancy >= ugroup[0].max_occupancy)
            classroomFull = true;
        }
        break;
      case "Career":
        if (updUser.preferredLanguage === "English") {
          ugroup = groups.filter((g) => g.name === "E06");
          if (ugroup[0].curr_occupancy >= ugroup[0].max_occupancy)
            classroomFull = true;
        }
        if (classroomFull && updUser.preferredLanguage === "English") {
          classroomFull = false;
          ugroup = groups.filter((g) => g.name === "E07");
          if (ugroup[0].curr_occupancy >= ugroup[0].max_occupancy)
            classroomFull = true;
        }
        break;
      case "Parent":
        if (updUser.preferredLanguage === "English" && updUser.age >= 45) {
          ugroup = groups.filter((g) => g.name === "E08");
          if (ugroup[0].curr_occupancy >= ugroup[0].max_occupancy)
            classroomFull = true;
        }
        break;
      case "Adult":
        if (updUser.preferredLanguage === "English" && updUser.age >= 45) {
          ugroup = groups.filter((g) => g.name === "E08");
          if (ugroup[0].curr_occupancy >= ugroup[0].max_occupancy)
            classroomFull = true;
        } else if (updUser.preferredLanguage === "English") {
          ugroup = groups.filter((g) => g.name === "E07");
          if (ugroup[0].curr_occupancy >= ugroup[0].max_occupancy)
            classroomFull = true;
          if (classroomFull) {
            classroomFull = false;
            ugroup = groups.filter((g) => g.name === "E06");
            if (ugroup[0].curr_occupancy >= ugroup[0].max_occupancy)
            classroomFull = true;
          }
        };
        break;
      default:
        console.log("User cannot find any group!");
    };
    console.log("updUser.grade, ugroup", updUser.grade, ugroup)

    // if (isGroupMaxCapacityReached(ugroup[0])) {
    //   classroomFull = true;
    // };

    if (classroomFull && (updatedRegistrationStatus === "Pending Acceptance"
      || updatedRegistrationStatus === "Accepted")) {
      console.log(`Class is full - ${ugroup[0].name} ${ugroup[0].description}`);
      alert(`Class is full - ${ugroup[0].name} ${ugroup[0].description}`);
    };

    console.log("classroomFull, updatedRegistrationStatus:", classroomFull, updatedRegistrationStatus)
    return ugroup.length && !classroomFull ? ugroup[0]._id : null;
  };


  function getGroupByAgeGradeFamily(updUser) {
    console.log("getGroupByAgeGradeFamily")
    classroomFullFamily = false;
    let usersFamily = [];
    console.log("filteredUsers:", filteredUsers);

    filteredUsers.forEach((u) => {
      let tempUserObj = { _id: u._id };
      if (u.familyId === updUser.familyId) {
        let tempUserObj = { _id: u._id };
        tempUserObj.group = getGroupByAgeGrade(u);

        // Even only one user's group is full in a family, the whole family will be impacted
        if (!classroomFullFamily) {
          classroomFull ? (classroomFullFamily = true) : (classroomFullFamily = false);
        }
        // ex. From "Pending Acceptance" or "Accepted" to 'To Be Confirmed'
        if (updatedRegistrationStatus === "Not Attending" ||
          !(updatedRegistrationStatus === "Pending Acceptance" || updatedRegistrationStatus === "Accepted")) {
          tempUserObj.group = null;
          tempUserObj.dorm = null;
        }
        usersFamily.push(tempUserObj);
      }
    });
    // Even when only one family member's class is full, all family memebers will be reverted back to the old status
    usersFamily.map(user => {
      // ex. From 'To Be Confirmed' to "Pending Acceptance" or "Accepted"
      if (capacityCheck && classroomFullFamily && (updatedRegistrationStatus === "Pending Acceptance"
        || updatedRegistrationStatus === "Accepted")) {
        user.registrationStatus = oldRegistrationStatus;
        user.group = null;
        user.dorm = null;
      } else {
        user.registrationStatus = updatedRegistrationStatus;
      };
    });

    console.log("usersFamily", usersFamily);
    console.log("classroomFullFamily", classroomFullFamily);

    return usersFamily.length ? usersFamily : null;
  };

  async function handleUpdate(sendEmail) {
    if (!updateUser || !updatedRegistrationStatus) {
      return;
    }

    // When status changed from "Pending Acceptance" to "Accepted", the seats have been reserved during the "Pending Acceptance" process.
    // As such, checking capacity of the classes is not needed
    if (oldRegistrationStatus === "Pending Acceptance" && updatedRegistrationStatus === "Accepted") {
      statusFromPAToAccepted = true;
    };

    // Individual - initialization
    let userObj = {
      registrationStatus: updatedRegistrationStatus,
    };

    if (updatedRegistrationStatus === "Not Attending" ||
      !(updatedRegistrationStatus === "Pending Acceptance" || updatedRegistrationStatus === "Accepted")) {
      userObj.group = null;
      userObj.dorm = null;
    };
    console.log("userObj", userObj);
    console.log("updateUser", updateUser);

    // Family - initialization
    let userObjs = [];
    filteredUsers.forEach((u) => {
      if (u.familyId === updateUser.familyId) {
        let tempUserObj = { _id: u._id };
        tempUserObj.registrationStatus = updatedRegistrationStatus;
        if (updatedRegistrationStatus === "Not Attending" ||
          !(updatedRegistrationStatus === "Pending Acceptance" || updatedRegistrationStatus === "Accepted")) {
          tempUserObj.group = null;
          tempUserObj.dorm = null;
        }
        userObjs.push(tempUserObj);
      }
    });
    console.log("userObjs", userObjs);

    // Get and set the group for user
    if (updateScope === "individual" && capacityCheck && !statusFromPAToAccepted) {
      userObj.group = getGroupByAgeGrade(updateUser);
      if (classroomFull && (updatedRegistrationStatus === "Pending Acceptance"
        || updatedRegistrationStatus === "Accepted")) {
        userObj.registrationStatus = oldRegistrationStatus;
      };
    } else if (updateScope === "family" && capacityCheck && !statusFromPAToAccepted) {
      userObjs = getGroupByAgeGradeFamily(updateUser);
    };

    // Update user to database
    try {
      if (updateScope === "individual") {
        const updatedUser = (
          await api.put(
            `/api/users/admin-table-format/${sendEmail ? "registration-status-email" : "registration-status"
            }/${updateUser._id}`,
            userObj
          )
        ).data;

        updateUser.registrationStatus = updatedUser.registrationStatus;
        updateUser.registerTimestamp = updatedUser.registerTimestamp;
      } else if (updateScope === "family") {
        const updatedFamily = (
          await api.put(
            `/api/users/admin-table-format/${sendEmail
              ? "registration-status-email-family"
              : "registration-status-family"
            }/${updateUser.familyId}`,
            userObjs
          )
        ).data;

        const updatedUsers = filteredUsers.map((oldUser) => {
          const updatedUser = updatedFamily.find((f) => f._id === oldUser._id);
          if (updatedUser) {
            return {
              ...oldUser,
              registrationStatus: updatedUser.registrationStatus,
              registerTimestamp: updatedUser.registerTimestamp,
            };
          }
          return oldUser;
        });

        setFilteredUsers(updatedUsers);
      }
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log(err);
    } finally {
      onClose();
    }

    setUpdateUser(null);
    setOldRegistrationStatus(null);
    setUpdatedRegistrationStatus(null);
    classroomFullFamily = false;
    groupCapacities = {};
    // setGroups(null);
    groups = null;
  }

  const handleSort = (field) => {
    const newSortOrder =
      sortBy === field && sortOrder === "asc" ? "desc" : "asc";
    setSortBy(field);
    setSortOrder(newSortOrder);
  };


  return (
    <Box display="flex" flexDirection="column" alignItems="center">
      <Heading textAlign="center" margin="20px">
        {language === "en" ? "Manage Registration Status" : "設定註册狀態"}
      </Heading>
      <AdminUserFilter
        setFilteredUsers={setFilteredUsers}
        setPageLoading={setPageLoading}
        pageNumber={pageNumber}
        setPageNumber={setPageNumber}
        pageSize={pageSize}
        setPageTotal={setPageTotal}
        pageNumberChange={pageNumberChange}
        sortBy={sortBy}
        sortOrder={sortOrder}
        sortByRegisterTimestamp
      />
      {pageLoading ? (
        <Spinner size="xl" />
      ) : (
        <>
          <Modal isOpen={isOpen} onClose={onClose} width="400px">
            <ModalOverlay />
            <ModalContent>
              <ModalHeader>Update Registration Status</ModalHeader>
              <ModalCloseButton />
              <ModalBody>
                {prettyPrintUser(updateUser)}
                <br /> <br />
                <Checkbox
                  variant={"outline"}
                  isChecked={capacityCheck}
                  onChange={(e) => setCapacityCheck(e.target.checked)}
                >
                  Automatically Check Group Capacity
                </Checkbox>
              </ModalBody>
              <ModalFooter>
                {updatedRegistrationStatus === "Waiting List" ||
                  updatedRegistrationStatus === "Pending Acceptance" ||
                  updatedRegistrationStatus === "Accepted" ? (
                  <Flex justify="flex-start">
                    <Button
                      variant="ghost"
                      colorScheme="teal"
                      margin={0}
                      marginTop={-15}
                      onClick={() => handleUpdate(true)}
                    >
                      Update and Send Email
                    </Button>

                    <Button
                      variant="ghost"
                      margin={0}
                      marginTop={-15}
                      onClick={() => handleUpdate(false)}
                    >
                      Update Only
                    </Button>
                  </Flex>
                ) : (
                  <Button
                    variant="ghost"
                    colorScheme="teal"
                    margin={3}
                    onClick={() => handleUpdate(false)}
                  >
                    Update
                  </Button>
                )}
                {/* <Button colorScheme="blue" margin={1} marginBottom={6} onClick={onClose} >
                  Cancel
                </Button> */}
                <></>
              </ModalFooter>
            </ModalContent>
          </Modal>
          <TableContainer margin={5}>
            <Table size="sm">
              <Thead>
                <Tr style={{ cursor: "pointer" }}>
                  <Th scope="col" onClick={() => handleSort("firstName")}>
                    First Name {renderArrow("firstName", sortBy, sortOrder)}
                  </Th>
                  <Th scope="col" onClick={() => handleSort("lastName")}>
                    Last Name {renderArrow("lastName", sortBy, sortOrder)}
                  </Th>
                  <Th scope="col" onClick={() => handleSort("chineseName")}>
                    Chin. Name {renderArrow("chineseName", sortBy, sortOrder)}
                  </Th>
                  <Th scope="col" onClick={() => handleSort("email")}>
                    Email {renderArrow("email", sortBy, sortOrder)}
                  </Th>
                  <Th scope="col" onClick={() => handleSort("familyId")}>
                    Fam. Id {renderArrow("familyId", sortBy, sortOrder)}
                  </Th>
                  <Th scope="col">Attending</Th>
                  <Th scope="col" onClick={() => handleSort("gender")}>
                    Gender {renderArrow("gender", sortBy, sortOrder)}
                  </Th>
                  <Th scope="col" onClick={() => handleSort("church")}>
                    Church {renderArrow("church", sortBy, sortOrder)}
                  </Th>
                  <Th scope="col" onClick={() => handleSort("age")}>
                    Age {renderArrow("age", sortBy, sortOrder)}
                  </Th>
                  <Th scope="col" onClick={() => handleSort("grade")}>
                    Grade {renderArrow("grade", sortBy, sortOrder)}
                  </Th>
                  <Th
                    scope="col"
                    onClick={() => handleSort("registerTimestamp")}
                  >
                    Registr. Time{" "}
                    {renderArrow("registerTimestamp", sortBy, sortOrder)}
                  </Th>
                  <Th
                    scope="col"
                    onClick={() => handleSort("registrationStatus")}
                  >
                    Registration Status{" "}
                    {renderArrow("registrationStatus", sortBy, sortOrder)}
                  </Th>
                  <Th scope="col"></Th>
                  <Th scope="col">For Registerer</Th>
                </Tr>
              </Thead>
              <Tbody>
                {filteredUsers &&
                  filteredUsers.map((u) => (
                    <Tr key={u._id}>
                      <Td>{u.firstName}</Td>
                      <Td>{prettyPrintLastName(u)}</Td>
                      <Td>{u.chineseName}</Td>
                      <Td>{u.email}</Td>
                      <Td>{u.familyId}</Td>
                      <Td>
                        {u.registrationStatus === "Not Attending"
                          ? "No"
                          : "Yes"}
                      </Td>
                      <Td>{u.gender}</Td>
                      <Td>
                        <Tooltip
                          label={u.church?.long_name || u.churchOther || ""}
                        >
                          {prettyPrintChurch(u)}
                        </Tooltip>
                      </Td>
                      <Td>{u.age >= 0 ? u.age : ""}</Td>
                      <Td>{u.grade}</Td>
                      <Td>
                        {u.registerTimestamp
                          ? new Date(u.registerTimestamp).toLocaleString([], {
                            dateStyle: "short",
                            timeStyle: "short",
                          })
                          : ""}
                      </Td>
                      <Td>
                        <Select
                          value={
                            u === updateUser
                              ? updatedRegistrationStatus
                              : u.registrationStatus
                          }
                          onChange={(e) => {
                            if (u !== updateUser) {
                              setOldRegistrationStatus(u.registrationStatus);
                            }
                            setUpdateUser(u);
                            setUpdatedRegistrationStatus(e.target.value);
                          }}
                        >
                          {config.REGISTRATION_STATUSES.map((status) => (
                            <option value={status} key={status}>
                              {status}
                            </option>
                          ))}
                        </Select>
                      </Td>
                      <Td>
                        <Button
                          colorScheme="green"
                          isDisabled={
                            !hasPermission(
                              user,
                              "manage_registration_status"
                            ) ||
                            u !== updateUser ||
                            updatedRegistrationStatus === oldRegistrationStatus
                          }
                          onClick={() => {
                            setUpdateScope("individual");
                            onOpen();
                          }}
                        >
                          Update
                        </Button>
                      </Td>
                      <Td>
                        {u.registerer == true && (
                          <Button
                            colorScheme="teal"
                            isDisabled={
                              !hasPermission(
                                user,
                                "manage_registration_status"
                              ) ||
                              u !== updateUser ||
                              updatedRegistrationStatus ===
                              oldRegistrationStatus
                            }
                            onClick={() => {
                              setUpdateScope("family");
                              onOpen();
                            }}
                          >
                            Update Family
                          </Button>
                        )}
                      </Td>
                    </Tr>
                  ))}
              </Tbody>
            </Table>
          </TableContainer>
          <AdminUserTableFooter
            pageNumber={pageNumber}
            setPageNumber={setPageNumber}
            pageSize={pageSize}
            setPageSize={setPageSize}
            pageTotal={pageTotal}
            pageNumberChange={pageNumberChange}
            setPageNumberChange={setPageNumberChange}
          />
        </>
      )
      }
    </Box >
  );
}

export default AdminManageRegistrationStatus;
